import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme, css } from 'styled-components';
import { LayoutConst, useModal } from "core/modules";
import { FlexBox, useIsMobile, Colors } from '@brg/ui';
import ArrowTopLarge from "../../icons/ArrowTopLarge";
import WPOnlinesIcon from 'shared/icons/onlines/WPOnlinesIcon';
import useQueryState from 'shared/hooks/useQueryState';
import TGOnlinesIcon from 'shared/icons/onlines/TGOnlinesIcon';
import almatylogo from "shared/pages/commdesign/images/icons/almatylogo.svg"
import almatydesign from "shared/pages/commdesign/images/icons/almatydesign.png"

interface Props {
  isMobile?: boolean;
}

const DefaultFooterWrapper = styled(FlexBox)`
  background: ${(p) => p.theme.footerView.backgroundColor};
  width: 100%;
  min-height: 280px;
  z-index: 1;
  position: relative;
  background: white;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  border-radius: 48px 48px 0px 0px;
  overflow: hidden;

  //   &.white-theme {
  //     background: white;
  //   }

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding-left: 16px;
    padding-right: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    border-radius: 20px 20px 0px 0px;
    position: absolute;
    bottom: -540px;
    height: 128vw;
    padding-left: 10px;
    padding-right: 10px;
    min-height: 360px;
  }
`;

const DefaultFooterContent = styled(FlexBox)`
  margin: 0 auto;
  width: 84.5vw;
  display: block;

  @media (max-width: 940px) {
    margin: 0;
  }
`;

const DefaultFooterItemsWrapper = styled(FlexBox)`
  width: 100%;
  margin-top: 72px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 940px) {
    margin-top: 29px;
  }

  @media (max-width: 720px) {
    height: 128px;
  }
`;

const DefaultFooterItems = styled(FlexBox)<Props>`
  display: flex;
  flex-direction: row;

  ${p => p?.isMobile ? css`
    flex-wrap: wrap;
  ` : null};

  height: 64px;

  > span {
    margin-left: 24px;
  }

  @media (max-width: 940px) {
    height: auto;
    width: 100%;
    justify-content: space-between;
  }
`;

const Text = styled.div`
  font-weight: 500;
  font-style: normal;
  color: rgba(0, 0, 0, 1);
  font-family: HSE Sans;
  font-variation-settings: 'wght' 500;
  font-size: 14.5px;
  line-height: 18px;
  letter-spacing: -0.1px;
`;

const LINK = styled.a`
  text-decoration: none;
  font-weight: 500;
  font-style: normal;
  color: rgba(144, 144, 144, 1);
  font-family: HSE Sans;
  font-size: 13.5px;
  line-height: 18px;
  letter-spacing: -0.1px;

  &:hover {
    text-decoration: none;
    color: #2D2F33;
  }
`;

const ButtonTop = styled.button<{ onlines?: boolean }>`
  border-style: none;
  background: transparent;
  box-sizing: content-box;
  outline: none;
  cursor: pointer;
  display: flex;
  flex-flow: row;
  place-items: center;
  color: rgba(144, 144, 144, 1);
  font-weight: 500;
  font-style: normal;
  font-family: HSE Sans;
  font-variation-settings: 'wght' 500;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.1px;

  & svg {
    circle {
      stroke: ${({ theme }) => theme.btns.hollow.border};
      display: none;
    }

    path {
      fill: ${Colors.galBlack47};
    }

    &:active {
      circle {
        stroke: ${({ theme }) => theme.btns.hollow.borderActive};
      }
    }
  }

  @media (max-width: 940px) {
    position: relative;
    right: -70px;
  }
`;

export const ApplyBtn = styled.a<{
  bg?: string
  big?: boolean
  w?: string
}>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 32px 14px;
  gap: 10px;

  width: ${p => p.w ? p.w : "292px"};
  height: 50px;

  background: ${p => p?.bg ? p.bg : "#1E369F"};
  border-radius: 16px;


  font-family: HSE Sans;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #fff;


  @media (max-width: 940px) {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    font-size: 13px;
    line-height: 22px;
    width: ${p => p.big ? "180px" : "130px"};
    min-height: 0;
    padding: 8px 16px 10px;
    height: auto;
  }

  &:hover {
    color: rgb(255, 255, 255);
  }
`;

function toTheTopScroll() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

const DesignSchoolLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 100;
  font-size: 24px;
`

const PhoneWrapper = styled.div`
  font-family: HSE Sans;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  color: #909090;

  @media screen and (max-width: 480px) {
    font-size: 13.5px;
    line-height: 18px;
  }
`

const AlmatyLogo = styled.div`
    width: 186px;
    height: 55px;
    background: url(${almatylogo});
    background-size: contain;
    background-position-x: center;
    background-repeat: no-repeat;
`

const AlmatyDesignLogo = styled.div`
    width: 117px;
    height: 55px;
    background: url(${almatydesign});
    background-size: contain;
    background-position-y: 1px;
    background-repeat: no-repeat;
`

type PropsT = {
  className?: string;
};

const CommdesignFooter: FC<PropsT> = () => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const modal = useModal();
  const isMobile = useIsMobile();
  const [{ lang }] = useQueryState();

  const scrollToTopButton = (
    <ButtonTop onClick={toTheTopScroll}>
      <div>Читать с начала</div>
      <ArrowTopLarge/>
    </ButtonTop>
  );

  useEffect(() => {
    if (isMobile) {
      i18n.changeLanguage(lang)
    }
  }, [i18n, lang, isMobile])

  return (
    <div id="footer-portal">
      <DefaultFooterWrapper style={{ border: theme.footer.border }}>
        <DefaultFooterContent>
          <DefaultFooterItemsWrapper>
            <DefaultFooterItems isMobile={isMobile}>
              <FlexBox offsetRight={161} direction='column' directionMobile='column' justify='start'>
                <FlexBox justifyMobile='flex-end'>
                  {isMobile && scrollToTopButton}
                </FlexBox>
                <FlexBox offsetBottom={18}>
                  <DesignSchoolLogoWrapper>
                    <AlmatyDesignLogo/>
                    x
                    <AlmatyLogo/>
                  </DesignSchoolLogoWrapper>
                </FlexBox>
                <FlexBox directionMobile='row' direction='row' gx={15}>
                  <ApplyBtn big lang={i18n.language} href="https://calendly.com/deziiign/free30" target="_blank">Бесплатная консультация</ApplyBtn>
                  <FlexBox offsetTopMobile={0} gx={24} gxMobile={24} style={{placeItems: "center"}}>
                    <a href='https://wa.me/message/WEDGXNMC6Z7SH1' target='_blank'>
                      <WPOnlinesIcon />
                    </a>
                    <a href='https://t.me/deziiignproject' target='_blank'>
                      <TGOnlinesIcon/>
                    </a>
                  </FlexBox>
                </FlexBox>
              </FlexBox>
              <FlexBox direction='column'
                       offsetTopMobile={24} wrapMobile='wrap' gy={20} width='453px' widthMobile={'calc(95vw - 32px)'}>
                <Text>Образовательная платформа. Выберите курс, собирайте портфолио проектов и начните карьеру в дизайне.</Text>
                <FlexBox direction="column" directionMobile="column" style={{width: "100%"}}>
                  <FlexBox justify='space-between' align='center'>
                    <LINK href="mailto:hello@deziiign.com">hello@deziiign.com</LINK>
                    <PhoneWrapper>+7 (985)-474-54-63</PhoneWrapper>
                  </FlexBox>
                  <FlexBox justify='space-between' offsetTop={20} directionMobile='column' offsetTopMobile={25} gyMobile={15}>
                    <LINK href="/legals/license" target="_blank">Политика конфиденциальности</LINK>
                    <LINK href="/legals/privacy" target="_blank">Юридические документы</LINK>
                  </FlexBox>
              </FlexBox>
                </FlexBox>
            </DefaultFooterItems>
            {!isMobile && scrollToTopButton}
          </DefaultFooterItemsWrapper>
        </DefaultFooterContent>
      </DefaultFooterWrapper>
    </div>
  );
};

export default CommdesignFooterimport { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme, css } from 'styled-components';
import { LayoutConst, useModal } from "core/modules";
import { FlexBox, useIsMobile, Colors } from '@brg/ui';
import ArrowTopLarge from "../../icons/ArrowTopLarge";
import WPOnlinesIcon from 'shared/icons/onlines/WPOnlinesIcon';
import useQueryState from 'shared/hooks/useQueryState';
import TGOnlinesIcon from 'shared/icons/onlines/TGOnlinesIcon';
import almatylogo from "shared/pages/commdesign/images/icons/almatylogo.svg"
import almatydesign from "shared/pages/commdesign/images/icons/almatydesign.png"

interface Props {
  isMobile?: boolean;
}

const DefaultFooterWrapper = styled(FlexBox)`
  background: ${(p) => p.theme.footerView.backgroundColor};
  width: 100%;
  min-height: 280px;
  z-index: 1;
  position: relative;
  background: white;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  border-radius: 48px 48px 0px 0px;
  overflow: hidden;

  //   &.white-theme {
  //     background: white;
  //   }

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding-left: 16px;
    padding-right: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    border-radius: 20px 20px 0px 0px;
    position: absolute;
    bottom: -540px;
    height: 128vw;
    padding-left: 10px;
    padding-right: 10px;
    min-height: 360px;
  }
`;

const DefaultFooterContent = styled(FlexBox)`
  margin: 0 auto;
  width: 84.5vw;
  display: block;

  @media (max-width: 940px) {
    margin: 0;
  }
`;

const DefaultFooterItemsWrapper = styled(FlexBox)`
  width: 100%;
  margin-top: 72px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 940px) {
    margin-top: 29px;
  }

  @media (max-width: 720px) {
    height: 128px;
  }
`;

const DefaultFooterItems = styled(FlexBox)<Props>`
  display: flex;
  flex-direction: row;

  ${p => p?.isMobile ? css`
    flex-wrap: wrap;
  ` : null};

  height: 64px;

  > span {
    margin-left: 24px;
  }

  @media (max-width: 940px) {
    height: auto;
    width: 100%;
    justify-content: space-between;
  }
`;

const Text = styled.div`
  font-weight: 500;
  font-style: normal;
  color: rgba(0, 0, 0, 1);
  font-family: HSE Sans;
  font-variation-settings: 'wght' 500;
  font-size: 14.5px;
  line-height: 18px;
  letter-spacing: -0.1px;
`;

const LINK = styled.a`
  text-decoration: none;
  font-weight: 500;
  font-style: normal;
  color: rgba(144, 144, 144, 1);
  font-family: HSE Sans;
  font-size: 13.5px;
  line-height: 18px;
  letter-spacing: -0.1px;

  &:hover {
    text-decoration: none;
    color: #2D2F33;
  }
`;

const ButtonTop = styled.button<{ onlines?: boolean }>`
  border-style: none;
  background: transparent;
  box-sizing: content-box;
  outline: none;
  cursor: pointer;
  display: flex;
  flex-flow: row;
  place-items: center;
  color: rgba(144, 144, 144, 1);
  font-weight: 500;
  font-style: normal;
  font-family: HSE Sans;
  font-variation-settings: 'wght' 500;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.1px;

  & svg {
    circle {
      stroke: ${({ theme }) => theme.btns.hollow.border};
      display: none;
    }

    path {
      fill: ${Colors.galBlack47};
    }

    &:active {
      circle {
        stroke: ${({ theme }) => theme.btns.hollow.borderActive};
      }
    }
  }

  @media (max-width: 940px) {
    position: relative;
    right: -70px;
  }
`;

export const ApplyBtn = styled.a<{
  bg?: string
  big?: boolean
  w?: string
}>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 32px 14px;
  gap: 10px;

  width: ${p => p.w ? p.w : "292px"};
  height: 50px;

  background: ${p => p?.bg ? p.bg : "#1E369F"};
  border-radius: 16px;


  font-family: HSE Sans;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #fff;


  @media (max-width: 940px) {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    font-size: 13px;
    line-height: 22px;
    width: ${p => p.big ? "180px" : "130px"};
    min-height: 0;
    padding: 8px 16px 10px;
    height: auto;
  }

  &:hover {
    color: rgb(255, 255, 255);
  }
`;

function toTheTopScroll() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

const DesignSchoolLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 100;
  font-size: 24px;
`

const PhoneWrapper = styled.div`
  font-family: HSE Sans;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  color: #909090;

  @media screen and (max-width: 480px) {
    font-size: 13.5px;
    line-height: 18px;
  }
`

const AlmatyLogo = styled.div`
    width: 186px;
    height: 55px;
    background: url(${almatylogo});
    background-size: contain;
    background-position-x: center;
    background-repeat: no-repeat;
`

const AlmatyDesignLogo = styled.div`
    width: 117px;
    height: 55px;
    background: url(${almatydesign});
    background-size: contain;
    background-position-y: 1px;
    background-repeat: no-repeat;
`

type PropsT = {
  className?: string;
};

const CommdesignFooter: FC<PropsT> = () => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const modal = useModal();
  const isMobile = useIsMobile();
  const [{ lang }] = useQueryState();

  const scrollToTopButton = (
    <ButtonTop onClick={toTheTopScroll}>
      <div>Читать с начала</div>
      <ArrowTopLarge/>
    </ButtonTop>
  );

  useEffect(() => {
    if (isMobile) {
      i18n.changeLanguage(lang)
    }
  }, [i18n, lang, isMobile])

  return (
    <div id="footer-portal">
      <DefaultFooterWrapper style={{ border: theme.footer.border }}>
        <DefaultFooterContent>
          <DefaultFooterItemsWrapper>
            <DefaultFooterItems isMobile={isMobile}>
              <FlexBox offsetRight={161} direction='column' directionMobile='column' justify='start'>
                <FlexBox justifyMobile='flex-end'>
                  {isMobile && scrollToTopButton}
                </FlexBox>
                <FlexBox offsetBottom={18}>
                  <DesignSchoolLogoWrapper>
                    <AlmatyDesignLogo/>
                    x
                    <AlmatyLogo/>
                  </DesignSchoolLogoWrapper>
                </FlexBox>
                <FlexBox directionMobile='row' direction='row' gx={15}>
                  <ApplyBtn big lang={i18n.language} href="https://calendly.com/deziiign/free30" target="_blank">Бесплатная консультация</ApplyBtn>
                  <FlexBox offsetTopMobile={0} gx={24} gxMobile={24} style={{placeItems: "center"}}>
                    <a href='https://wa.me/message/WEDGXNMC6Z7SH1' target='_blank'>
                      <WPOnlinesIcon />
                    </a>
                    <a href='https://t.me/deziiignproject' target='_blank'>
                      <TGOnlinesIcon/>
                    </a>
                  </FlexBox>
                </FlexBox>
              </FlexBox>
              <FlexBox direction='column'
                       offsetTopMobile={24} wrapMobile='wrap' gy={20} width='453px' widthMobile={'calc(95vw - 32px)'}>
                <Text>Образовательная платформа. Выберите курс, собирайте портфолио проектов и начните карьеру в дизайне.</Text>
                <FlexBox direction="column" directionMobile="column" style={{width: "100%"}}>
                  <FlexBox justify='space-between' align='center'>
                    <LINK href="mailto:hello@deziiign.com">hello@deziiign.com</LINK>
                    <PhoneWrapper>+7 (985)-474-54-63</PhoneWrapper>
                  </FlexBox>
                  <FlexBox justify='space-between' offsetTop={20} directionMobile='column' offsetTopMobile={25} gyMobile={15}>
                    <LINK href="/legals/license" target="_blank">Политика конфиденциальности</LINK>
                    <LINK href="/legals/privacy" target="_blank">Юридические документы</LINK>
                  </FlexBox>
              </FlexBox>
                </FlexBox>
            </DefaultFooterItems>
            {!isMobile && scrollToTopButton}
          </DefaultFooterItemsWrapper>
        </DefaultFooterContent>
      </DefaultFooterWrapper>
    </div>
  );
};

export default CommdesignFooter